import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  Box,
  Typography,
  Button,
  Grid,
  LinearProgress,
} from "@material-ui/core";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    // maxWidth: 1000,
  },
  barColor: {
    backgroundColor: "#1ED059",
  },

  barRoot: {
    height: "1rem",
    borderRadius: "8px",
  },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {},
  },
}))(TableRow);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgba(246, 48, 169, 0.1)",
    fontWeight: 700,
    fontSize: 10,

    color: theme.palette.text.secondary,
  },
  body: {
    fontSize: 10,
  },
}))(TableCell);

function createData(months, poolvalue, progress, followersreached) {
  return { months, poolvalue, progress, followersreached };
}

const rows = [
  createData("January", "1,250 ETH", "100%", "13M"),
  createData("February", "1,500 ETH", "100%", "13M"),
  createData("March", "2,050 ETH", "100%", "13M"),
  createData("April", "1,120 ETH", "100%", "13M"),
  createData("May", "2,100 ETH", "100%", "13M"),
  createData("June", "1,250 ETH", "100%", "13M"),
  createData("July", "1,500 ETH", "50%", "13M"),
  createData("August", "2,050 ETH", "60%", "13M"),
  createData("September", "1,120 ETH", "40%", "13M"),
  createData("Octpber", "2,100 ETH", "60%", "13M"),
  createData("November", "1,120 ETH", "40%", "13M"),
  createData("December", "2,100 ETH", "80%", "13M"),
];

export default function DashboardTable() {
  const classes = useStyles();

  const MyTypography = ({ children }) => {
    return (
      <Typography
        style={{ fontSize: "1rem", fontWeight: "500", textAlign: "center" }}
      >
        {" "}
        {children}
      </Typography>
    );
  };

  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress
            variant="determinate"
            value={props.value}
            style={{ backgroundColor: "#B2F2C6" }}
            classes={{ bar: classes.barColor, root: classes.barRoot }}
          />
        </Box>
        <Box minWidth={35}>
          <MyTypography>{`${Math.round(props.value)}%`}</MyTypography>
        </Box>
      </Box>
    );
  }
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <StyledTableRow>
            <StyledTableCell align="center">Months</StyledTableCell>
            <StyledTableCell align="center">Total Pool Value</StyledTableCell>
            <StyledTableCell align="center">Progress</StyledTableCell>

            <StyledTableCell align="center">Followers Reached</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.months}>
              <TableCell component="th" scope="row">
                <MyTypography> {row.months}</MyTypography>
              </TableCell>

              <TableCell align="center">
                <MyTypography> {row.poolvalue}</MyTypography>
              </TableCell>

              <TableCell align="center">
                <LinearProgressWithLabel value={parseFloat(row.progress)} />
              </TableCell>

              <TableCell align="center">
                {" "}
                <MyTypography> {row.followersreached}</MyTypography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
